import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CheckboxGroup, Checkbox } from '@paypalcorp/pp-react-checkbox';
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react';
import { MessageFormat } from '@paypalcorp/worldready';

class CheckboxGroupField extends Component {
  static propTypes = {
    input: PropTypes.object,
    options: PropTypes.array,
    checkedFrequencies: PropTypes.array,
  };

  render() {
    const { options, input, checkedFrequencies } = this.props;

    let errorText = '';
    if (checkedFrequencies.length > 2) {
      errorText = new MessageFormat(this.context, {
        id: 'buttonsV3.recurringFrequencyOptions.recurringError1',
      }).format();
    }
    if (checkedFrequencies.length === 0) {
      errorText = new MessageFormat(this.context, {
        id: 'buttonsV3.recurringFrequencyOptions.recurringError2',
      }).format();
    }

    return (
      <CheckboxGroup
        error={
          checkedFrequencies.length === 3 || checkedFrequencies.length === 0
        }
        errorText={errorText}
      >
        {options.map((option, index) => {
          return (
            <Checkbox
              id={option.id}
              key={index}
              label={option.label}
              name={option.name}
              onChange={(e) => {
                const newValue = [...input.value];
                if (e.target.checked) {
                  newValue.push(option.name);
                } else {
                  newValue.splice(newValue.indexOf(option.name), 1);
                }
                return input.onChange(newValue);
              }}
              checked={checkedFrequencies.indexOf(option.name) !== -1}
            />
          );
        })}
      </CheckboxGroup>
    );
  }
}

CheckboxGroupField.contextType = WorldReadyContext;

export default CheckboxGroupField;
